import { useMutation, useQueryClient } from "@tanstack/react-query";
import { couponsKeys } from "Api/Queries/Coupons/useCouponsQuery";
import {
  type CreateCouponCommandResult,
  type CreateCouponRequest,
  postCoupons,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: CreateCouponCommandResult) => void;
  onError?: () => void;
};

export const useCreateCouponMutation = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: CreateCouponRequest) => postCoupons(data),
    ),
    onSuccess: (data: CreateCouponCommandResult) => {
      queryClient.invalidateQueries({ queryKey: couponsKeys.all });
      onSuccess?.(data);
    },
    onError,
  });
};
